function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.9 21H22L12 3 2 21H19.9zM8.2 13.9L12 7l3.8 6.9L12 12l-3.8 1.9z",
  fill: "currentColor"
});

var SvgLocationPeak = function SvgLocationPeak(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
};

export default SvgLocationPeak;